import { ArrowLeft } from "lucide-react";
import { Button } from "~/components/ui/button";

export function CalendarLayout({ children, title, description, logo, partnerName, infos, onBack }: Props) {
  return (
    <div className="flex flex-col divide-x rounded-[32px] border xl:h-[600px] xl:flex-row">
      <div className="flex flex-col space-y-3 rounded-t-[32px] bg-white p-4 sm:space-y-4 sm:p-8 xl:w-1/3 xl:rounded-r-none">
        <div className="flex items-center justify-between">
          {logo && <img src={logo} alt="Logo" className="h-10 sm:h-14" />}
          {onBack && (
            <Button size="icon" variant="outline" onClick={onBack}>
              <ArrowLeft />
            </Button>
          )}
        </div>
        <p className="text-base font-bold text-gray-500 sm:text-lg">{partnerName}</p>
        <p className="text-xl font-bold sm:text-2xl">{title}</p>
        <p className="text-sm text-gray-500 sm:text-base">{description}</p>
        {infos.length > 0 && (
          <div className="flex flex-col space-y-3 pt-4 sm:space-y-4 sm:pt-8">
            {infos.map((info) => (
              <div key={info.label} className="flex items-center space-x-2">
                {info.icon}
                <p>{info.label}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="h-full overflow-y-auto rounded-b-[32px] bg-white xl:w-2/3 xl:rounded-b-none">{children}</div>
    </div>
  );
}

interface Props {
  children: React.ReactNode;
  title: string;
  partnerName?: string;
  description?: string;
  logo?: string;
  infos: {
    icon: React.ReactNode;
    label: string;
  }[];
  onBack?: () => void;
}
